import { useContext, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { OverlayContext } from "../../../context/overlay.context";
import Utility from "../../Utility/Utility";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var Overlay = function Overlay(_ref) {
  var children = _ref.children;
  var context = useContext(OverlayContext);
  var addPortal = context.addPortal,
    removePortal = context.removePortal,
    portalRefs = context.portalRefs;
  var id = useRef(Utility.generateUID('overlay')).current;
  useEffect(function () {
    addPortal(id);
    return function () {
      return removePortal(id);
    };
  }, [id, addPortal, removePortal]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: context.overlayProvider ? /*#__PURE__*/_jsx(_Fragment, {
      children: portalRefs[id] ? /*#__PURE__*/ReactDOM.createPortal(children, portalRefs[id]) : null
    }) : /*#__PURE__*/_jsx("span", {
      children: "To use this Overlay, wrap the application with OverlayProvider"
    })
  });
};